import React from "react";

import { Loader2 } from "lucide-react";

import { Button } from "~/components/ui/button";

interface SubmitButtonProps {
  isSubmitting: boolean;
  className?: string;
  label?: string;
  loadingLabel?: string;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
  isSubmitting,
  className,
  label = "Registrar Pago",
  loadingLabel = "Procesando...",
}) => {
  return (
    <Button type="submit" className={className} disabled={isSubmitting}>
      {isSubmitting ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          {loadingLabel}
        </>
      ) : (
        label
      )}
    </Button>
  );
};

export default SubmitButton;
